import urlcat from 'urlcat';
import { BaseController } from '~/utils/base-controller';

export default class extends BaseController {
	/* @ngInject */
	constructor($injector, $sce, $element) {
		super($injector);

		const token = this.$rootScope.context.token.id;
		const endpoint = this.$rootScope.appConfig.config.V5.url;

		const url = urlcat(endpoint, '/admin/batch', {
			token,
			engine: 4,
		});

		// eslint-disable-next-line
		console.log('url', url);

		this.src = $sce.trustAsResourceUrl(url);
		this.$element = $element;
		this.isLoading = true;
	}

	$onInit() {
		const iframe = this.$element.find('iframe');
		iframe.on('load', () => {
			this.$timeout(() => {
				this.isLoading = false;
			});
		});
	}
}
